// @flow

export const GTM_EVENT_ADD_PAYMENT_INFO = 'add_payment_info';
export const GTM_EVENT_ADD_SHIPPING_INFO = 'add_shipping_info';
export const GTM_EVENT_VIEW_CART = 'view_cart';
export const GTM_EVENT_BEGIN_CHECKOUT = 'begin_checkout';
export const GTM_EVENT_CHECKOUT = 'checkout';
export const GTM_EVENT_PURCHASE = 'purchase';
export const GTM_EVENT_PSD2 = 'PSD2';
export const GTM_EVENT_PAGE_VIEW = 'page_view';
export const GTM_EVENT_PICTURE_GALLERY = 'gallery';

export const GTM_EVENTACTION_PURCHASE = 'purchase_confirmed';
export const GTM_EVENTACTION_GALLERY_DETAILS_OPEN = 'open_gallery_details';
export const GTM_EVENTACTION_GALLERY_SLIDER_PREVIOUS =
  'gallery_slider_previous_click';
export const GTM_EVENTACTION_GALLERY_SLIDER_NEXT = 'gallery_slider_next_click';
export const GTM_EVENTACTION_GALLERY_DETAILS_CLOSE = 'close_gallery_details';
export const GTM_EVENTACTION_USERVOUCHER_SHOWN = 'users_voucher_shown';
export const GTM_EVENTACTION_CLICK = 'click';
export const GTM_EVENTACTION_CUSTOMER_IS_TRAVELER = 'customer_is_traveler';
